import { useImageLightboxState } from '@application/state';
import type { SlideshowData } from '@presentation/components';
import { useCallback, useState } from 'react';

export const useSlideshow = (
  items: SlideshowData['items'],
  initialIndex: SlideshowData['index'] = 0,
): SlideshowData => {
  const [index, setIndex] = useState(initialIndex);
  const { open } = useImageLightboxState();

  const onImageClick: SlideshowData['onImageClick'] = useCallback(() => {
    const images = items.filter((item) => !item.isVideo).map((item) => item.src);
    return open(images, index);
  }, [index, items, open]);

  const onNext: SlideshowData['onNext'] = useCallback(() => {
    return setIndex((index + 1) % items.length);
  }, [index, items.length]);

  const onPrevious: SlideshowData['onPrevious'] = useCallback(() => {
    return setIndex((index + items.length - 1) % items.length);
  }, [index, items.length]);

  const onThumbnailClick: SlideshowData['onThumbnailClick'] = useCallback((clickedIndex) => {
    return setIndex(clickedIndex);
  }, []);

  return { items, index, onImageClick, onNext, onPrevious, onThumbnailClick };
};
